module.exports = __webpack_public_path__ + "img/32b5af0.jpg";